import { render, staticRenderFns } from "./VuelvePromo.vue?vue&type=template&id=1b85f840&scoped=true&"
import script from "./VuelvePromo.vue?vue&type=script&lang=js&"
export * from "./VuelvePromo.vue?vue&type=script&lang=js&"
import style0 from "./VuelvePromo.vue?vue&type=style&index=0&id=1b85f840&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b85f840",
  null
  
)

export default component.exports